import React, { ReactNode, useContext } from 'react';
import { SustainabilityLandingPageConstants } from 'src/constants/ProjectConstants';
import { SUSTAINABILITY_FAQ_DOWNLOAD_URL } from 'src/constants/UrlConstants';
import { TranslationContext } from 'src/state/providers/TranslationProvider';

export const TrustSectionBody = () => {
  const { socialResponsibilityLandingPageBundle } =
    useContext(TranslationContext);
  return (
    <div data-testid="trust-section-body">
      <h4>
        {socialResponsibilityLandingPageBundle.getMessage(
          SustainabilityLandingPageConstants.TRUST_SECTION_DESCRIPTION_HEADER,
        )}
      </h4>
      <p>
        {socialResponsibilityLandingPageBundle.getMessage(
          SustainabilityLandingPageConstants.TRUST_SECTION_DESCRIPTION_INFORMATION,
        )}
        <ul>
          <li>
            {socialResponsibilityLandingPageBundle.getMessage(
              SustainabilityLandingPageConstants.AFFECTED_CATEGORY_CHILD_LABOUR_YOUNG_WORKERS,
            )}
          </li>
          <li>
            {socialResponsibilityLandingPageBundle.getMessage(
              SustainabilityLandingPageConstants.AFFECTED_CATEGORY_FORCED_LABOUR_MODERN_SLAVERY,
            )}
          </li>
          <li>
            {socialResponsibilityLandingPageBundle.getMessage(
              SustainabilityLandingPageConstants.AFFECTED_CATEGORY_OCCUPATION_HEALTH_SAFETY,
            )}
          </li>
          <li>
            {socialResponsibilityLandingPageBundle.getMessage(
              SustainabilityLandingPageConstants.AFFECTED_CATEGORY_WAGES_AND_BENEFITS,
            )}
          </li>
          <li>
            {socialResponsibilityLandingPageBundle.getMessage(
              SustainabilityLandingPageConstants.AFFECTED_CATEGORY_WORKING_HOURS,
            )}
          </li>
          <li>
            {socialResponsibilityLandingPageBundle.getMessage(
              SustainabilityLandingPageConstants.AFFECTED_CATEGORY_DISCRIMINATION_AND_HARRASMENT,
            )}
          </li>
          <li>
            {socialResponsibilityLandingPageBundle.getMessage(
              SustainabilityLandingPageConstants.AFFECTED_CATEGORY_UNETHICAL_BEHAVOUR_AND_CORRUPTION,
            )}
          </li>
          <li>
            {socialResponsibilityLandingPageBundle.getMessage(
              SustainabilityLandingPageConstants.AFFECTED_CATEGORY_RIGHT_TO_PEACEFULY_ASSOCIATE_ASSAMBLE_WITH_OTHERS,
            )}
          </li>
          <li>
            {socialResponsibilityLandingPageBundle.getMessage(
              SustainabilityLandingPageConstants.AFFECTED_CATEGORY_LAND_AND_NATURAL_RESOURCES,
            )}
          </li>
          <li>
            {socialResponsibilityLandingPageBundle.getMessage(
              SustainabilityLandingPageConstants.AFFECTED_CATEGORY_HAZARDOUS_WASTE_MANAGEMENT_AND_DISPOSE,
            )}
          </li>
        </ul>
      </p>
      <div>
        <p>
          {socialResponsibilityLandingPageBundle.formatMessage(
            SustainabilityLandingPageConstants.TRUST_SECTION_DESCRIPTION_WHAT_NOT_TO_REPORT,
            {
              b: (chunks: ReactNode) => <b>{chunks}</b>,
            },
          )}
        </p>
        <p>
          {socialResponsibilityLandingPageBundle.getMessage(
            SustainabilityLandingPageConstants.TRUST_SECTION_DESCRIPTION_EMERFENCY_REPORTING,
          )}
        </p>
        <p>
          {socialResponsibilityLandingPageBundle.formatMessage(
            SustainabilityLandingPageConstants.TRUST_SECTION_DESCRIPTION_FAQ,
            {
              a: (chunks: ReactNode) => (
                <a href={SUSTAINABILITY_FAQ_DOWNLOAD_URL} target="_blank">
                  {chunks}
                </a>
              ),
            },
          )}
        </p>
      </div>
    </div>
  );
};
